export default __webpack_public_path__ + "static/media/boots_of_fiendish_invocation.db78967e.jpg";